var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.665 18V16C18.665 14.9391 18.1909 13.9217 17.347 13.1716C16.5031 12.4214 15.3585 12 14.165 12H5.16501C3.97153 12 2.82694 12.4214 1.98303 13.1716C1.13911 13.9217 0.665009 14.9391 0.665009 16V18",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66501 0.665039C11.5069 0.665039 13 2.15813 13 4C13 5.84187 11.5069 7.33496 9.66501 7.33496C7.82314 7.33496 6.33005 5.84187 6.33005 4C6.33005 2.15813 7.82314 0.665039 9.66501 0.665039Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutlined);
export default __webpack_public_path__ + "static/media/person_outlined.7f4888c226b879aeedb858279bf967d8.svg";
export { ForwardRef as ReactComponent };